// extracted by mini-css-extract-plugin
export var breadcrumb = "_1e-0";
export var breadcrumbArrow = "_1e-1";